import { useAxios } from './axiosService';

export const useEmailLogService = () => {
    const { axios: instance } = useAxios();

    // the page shows its own error, so a failed load does not navigate to the global error page
    const getEmailLog = async params =>
        (await instance.get('/email-log', { params, skipGlobalErrorHandler: true })).data;

    // one email with its body (links' tokens and codes already hidden by the API)
    const getEmailLogEntry = async id =>
        (await instance.get(`/email-log/${id}`, { skipGlobalErrorHandler: true })).data;

    return { getEmailLog, getEmailLogEntry };
};
